interface FAQItem {
  question: string;
  answer: string;
}

interface BreadcrumbItem {
  name: string;
  url: string;
}

const SITE_URL = 'https://jurassicjack.com.au';

export function localBusinessSchema() {
  return JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Jurassic Jack',
    description:
      'Premium roaming dinosaur entertainment for agricultural shows, festivals, schools and community events across Victoria.',
    url: SITE_URL,
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Geelong',
      addressRegion: 'VIC',
      addressCountry: 'AU',
    },
    telephone: '+61400000000',
    email: 'bookings@jurassicjack.com.au',
    image: `${SITE_URL}/images/jurassic-jack-logo-red-black-022.png`,
    priceRange: 'AUD $3500-$12000',
    areaServed: {
      '@type': 'State',
      name: 'Victoria',
      containedInPlace: {
        '@type': 'Country',
        name: 'Australia',
      },
    },
  });
}

export function faqPageSchema(items: FAQItem[]) {
  return JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  });
}

export function breadcrumbSchema(items: BreadcrumbItem[]) {
  return JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: item.name,
      item: item.url,
    })),
  });
}

export { SITE_URL };
